/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  if (window.innerWidth > 799) {
    ScrollReveal().reveal('.discounts .sr-hidden', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      once: true,
      interval: 100
    });
  }
});